import React from 'react'
import Invoice_header from '../Header/Invoice_header'
import "../../styles/scope.css";
import { useState, useRef, useEffect } from "react";
import { ToastContainer, toast } from "react-toastify"
import DatePicker from "react-datepicker";
import ReactPaginate from "react-paginate";
import { useNavigate } from 'react-router-dom';
import "../../styles/invoice_addnew.css";
import excel_icon from "../../assets/svg/excel_icon.svg";
import upload_icon from "../../assets/svg/upload_icon.svg";
import download_icon from "../../assets/svg/download_icon.svg";
import axios from 'axios';
import Vector from "../../assets/svg/editIcon.svg";
import Delete from "../../assets/svg/DeleteIcon.svg";
import BulkDeleteIcon from "../../assets/svg/sap-bulk-delete-icon.svg";
import checked_icon from "../../assets/svg/checked_icon.svg";
import filterOpenCloseIcon from "../../assets/svg/filterOpenCloseIcon.svg";
import back_arrow from "../../assets/svg/back-arrow.svg";
import removed_icon from "../../assets/svg/removed_icon.svg";
import axiosInstance from '../../axiosInstance';
import download_arrow from "../../assets/svg/download_arrow.svg";
import { usePermissions } from '../../hooks/PermissionContext';
import PermissionWrapper from '../../hooks/PermissionWrapper';
import AdditionalPermissionWrapper from '../../hooks/AdditionalPermissionWrapper';
import ConfirmDialog from '../../ConfirmDialog/ConfirmDialog';
import CommonFooter from '../../CommonFooter/CommonFooter';
import { FaChevronDown } from "react-icons/fa";
import AsyncSelect from "react-select/async";
import { FaEdit } from "react-icons/fa";
import CommonPagination from '../../CommonPagination/CommonPagination';
import ApproveRejectPopup from './ApproveRejectPopup';
import SalesInvoiceFilter from './SalesInvoiceFilter';


const SalesInvoice = () => {

    let ModuleId = 24
    const { getModulePermission } = usePermissions();
    const permission = getModulePermission(ModuleId);
    console.log("activeModuleId", ModuleId);
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [deleteId, setDeleteId] = useState(null);
    const [remarks, setRemarks] = useState("");
    const [tableData, setTableData] = useState([]);
    const [error, setError] = useState(null);
    const [limit, setLimit] = useState(5);
    const [actionType, setActionType] = useState("");
    const [isModalOpen, setModalOpen] = useState(false);
    const [invoiceComments, setInvoiceComments] = useState({});
    const [commentError, setCommentError] = useState('');
    const [currentPage, setCurrentPage] = useState(0);
    const [comment, setComment] = useState("");
    const [skip, setSkip] = useState(0);
    const [total, setTotal] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);
    const popupRef = useRef(null);
    const [editData, setEditData] = useState(null);
    const [activeTab, setActiveTab] = useState("all");
    const [showSapButton, setShowSapButton] = useState(false);
    const [showBulkSubmitButton, setShowBulkSubmitButton] = useState(false);
    const [isHovered, setIsHovered] = useState(false);
    const [confirmBulkSubmitOpen, setConfirmBulkSubmitOpen] = useState(false);
    const [isSapBulkDeleteConfirmOpen, setIsSapBulkDeleteConfirmOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [sapDocNumber, setSapDocNumber] = useState("");
    const [staticProject, setStaticProject] = useState([]);
    const [filterDateRange, setFilterDateRange] = useState([null, null]);
    const [fromDate, toDate] = filterDateRange;
    const [openByArrow, setOpenByArrow] = useState(false);
    const [showFilters, setShowFilters] = useState(true);
    const [selectedInvoice, setSelectedInvoice] = useState([]);
    const [isBulkCancelModalOpen, setIsBulkCancelModalOpen] = useState(false);
    const [invoiceCancelAction, setInvoiceCancelAction] = useState("");
    const [supplyPeriod, setSupplyPeriod] = useState(null);
    const [modifiedBillingNature, setModifiedBillingNature] = useState("");
    const [isFinalInvoiceBulkCancelOpen, setIsFinalInvoiceBulkCancelOpen] = useState(false);
    const [appliedFilters, setAppliedFilters] = useState({});
    const [activeInvoice, setActiveInvoice] = useState(null);
    const [modificationReason, setModificationReason] = useState("");

    const [isBulkModificationOpen, setIsBulkModificationOpen] = useState(false);
    const [bulkRemarks, setBulkRemarks] = useState({});
    const [bulkModificationInvoices, setBulkModificationInvoices] = useState([]);
    const [globalCancelRemark, setGlobalCancelRemark] = useState("");
    const [remarkToCustomer, setRemarkToCustomer] = useState(null);
    const [isBulkDeleteOpen, setIsBulkDeleteOpen] = useState(false);
    const [bulkDeleteRemarks, setBulkDeleteRemarks] = useState({});
    const [bulkDeleteInvoices, setBulkDeleteInvoices] = useState([]);
    const [isApproveLoading, setIsApproveLoading] = useState(false);
    const [profitCenter, setProfitCenter] = useState([]);
    const [city, setCity] = useState([]);
    const [state, setState] = useState([]);
    const [zone, setZone] = useState([]);
    const [plantCode, setPlantCode] = useState([]);
    const [showFilter, setShowFilter] = useState(true);
    const [divisionType, setDivisionType] = useState("");
    const selectedInvoices = tableData.filter(inv =>
        selectedRows.includes(inv.id)
    );

    const handleBulkRemarkChange = (invoiceId, value) => {
        setBulkRemarks(prev => ({
            ...prev,
            [invoiceId]: value
        }));
    };

    const [uploadedFiles, setUploadedFiles] = useState({
        UPLOAD: [],
        SI: [],
    });
    const [loading, setLoading] = useState(false);
    const [sortBy, setSortBy] = useState("dateCreated");
    const [statusCounts, setStatusCounts] = useState({
        all: 0,
        draft: 0,
        submitted: 0,
        rejected: 0,
        sapPushed: 0,
        final: 0
    });
    const [showSapBulkActions, setShowSapBulkActions] = useState(false);
    const [showFinalBulkCancel, setShowFinalBulkCancel] = useState(false);
    const calculateStatusCounts = (total) => {
        return {
            all: total,
            draft: total,
            submitted: total,
            rejected: total,
            sapPushed: total,
            final: total
        };
    };

    const openModal = (type, invoice) => {
        setActionType(type);
        setActiveInvoice(invoice);
        setModalOpen(true);
    };

    const closeModal = () => {
        setModalOpen(false);
        setComment("");
    };

    useEffect(() => {
        if (tableData.length > 0) {
            setStatusCounts(calculateStatusCounts(total));
        }
        console.log("totalcount", total);
    }, [tableData]);

    const fetchAll = () => {
        fetchData({
            skip: 0,
            limit,
            type: "sales",
            filter: {
                status: activeTab.toLowerCase()
            },
            search: searchTerm
        });
    };

    useEffect(() => {
        setSelectedInvoice([]);
        setStaticProject([]);
        setSapDocNumber("");
        setPlantCode([]);
        setFilterDateRange([null, null]);
        setAppliedFilters({});
        setCurrentPage(0);
        setProfitCenter([]);
        setDivisionType("");
        setCity([]);
        setState([]);
        setZone([]);
        setSkip(0);
        fetchAll();
        setSelectedRows([]);
        setShowSapButton(false);
        setShowBulkSubmitButton(false);
        setShowSapBulkActions(false);
        setShowFinalBulkCancel(false);
    }, [activeTab]);

    const handleSapPush = async () => {
        try {
            console.log('Sending SAP trigger request with invoice IDs:', selectedRows);

            const response = await axiosInstance.post('/sap_trigger', {
                invoice_ids: selectedRows
            });

            console.log('SAP trigger response:', response);

            if (response.status === 200) {
                alert("SAP push successful!");
                setSelectedRows([]);
                setShowSapButton(false);
                // Consider refreshing the data after successful push
                fetchData();
            } else {
                alert(`SAP push failed! Status: ${response.status}`);
            }
        } catch (error) {
            console.error("SAP push error:", {
                message: error.message,
                response: error.response,
                stack: error.stack
            });

            let errorMessage = "Something went wrong with SAP push!";
            if (error.response) {
                errorMessage += `\nStatus: ${error.response.status}`;
                if (error.response.data) {
                    errorMessage += `\nError: ${JSON.stringify(error.response.data)}`;
                }
            }
            alert(errorMessage);
        }
    };

    const handleBulkSubmit = () => {
        if (selectedRows.length === 0) return;
        setConfirmBulkSubmitOpen(true);
    };

    const confirmBulkSubmit = async () => {
        setConfirmBulkSubmitOpen(false);

        try {
            const response = await axiosInstance.post('/invoice/draft_bulkSubmit', {
                invoice_ids: selectedRows
            });

            if (response.data.success) {
                toast.success(`${selectedRows.length} invoices submitted successfully!`);
                setSelectedRows([]);
                setShowBulkSubmitButton(false);

                const payload = {
                    skip: 0,
                    limit: limit,
                    type: 'sales',
                    filter: { status: "draft" }
                };
                fetchData(payload);
            } else {
                toast.error(response.data.message || "Failed to submit invoices");
            }
        } catch (error) {
            toast.error(error.response?.data?.message || "Failed to submit invoices");
            console.error("Bulk submit error:", error);
        }
    };

    const cancelBulkSubmit = () => {
        setConfirmBulkSubmitOpen(false);
    };

    const handleInvoiceAction = async (invoiceId, projectId, data) => {
        if (!data.comments?.trim()) {
            toast.error("Comment is required");
            return;
        }

        const payload = {
            invoice_id: invoiceId,
            project_id: projectId,
            module: "3",
            invoice_type: "sales",
            comments: data.comments,
            status: actionType,
            plant_id: data.plant_id,
            plant_code: data.plant_code,
            billing_nature: data.billing_nature,
            supply_period: data.supply_period,
            billing_date: data.billing_date,
            customer_remarks: data.customer_remarks,
            po_wo_number: data.po_wo_number,
            po_wo_date: data.po_wo_date
        };
        if (isApproveLoading) return;

        setIsApproveLoading(true);

        try {
            const response = await axiosInstance.post(`/approve_reject_btns`, payload);

            if (response.status === 200) {
                toast.success(`Invoice ${actionType} successfully!`);

                fetchData({
                    skip: 0,
                    limit,
                    type: 'sales',
                    filter: { status: activeTab },
                });
            } else {
                toast.error(`Failed to ${actionType} invoice`);
            }
        } catch (error) {
            toast.error(`Error while ${actionType} invoice`);
        } finally {
            setIsApproveLoading(false);
            closeModal();
        }
    };


    const fetchData = async (payload) => {
        try {

            const requestPayload = payload || {
                skip: skip,
                limit: limit,
                type: 'sales',
                sortBy: sortBy,
                filter: {
                    status: activeTab.toLowerCase()
                },
                search: searchTerm
            };

            // const response = await axios.post(
            //     'https://digitallr-uat.flyjaclogistics.com/cost_modelling-be/invoice/invoice_list',
            //     requestPayload,
            // );

            const response = await axiosInstance.post(
                '/invoice/invoice_list',
                requestPayload,
            );

            console.log("invoice list response", response);

            if (response.data && Array.isArray(response.data.job)) {
                setTableData(response.data.job);
                const newTotal = response.data.totalCount || 0;
                setTotal(newTotal);
                setTotalPages(Math.ceil(newTotal / limit));
            } else {
                setTableData([]);
                setTotal(0);
                setTotalPages(0);
            }
        } catch (error) {
            setError(error.message);
            console.error("There was a problem with the API request:", error);
        } finally {
            setLoading(false);
        }
    };



    // Rest of your useEffect hooks remain the same
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (popupRef.current && !popupRef.current.contains(event.target)) {
                closePopup();
            }
        };
        if (isPopupOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        }
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [isPopupOpen]);

    const handlePageClick = ({ selected }) => {
        const newSkip = selected * limit;
        setCurrentPage(selected);
        setSkip(newSkip);

        fetchData({
            skip: newSkip,
            limit,
            type: 'sales',
            filter: {
                status: activeTab.toLowerCase(),
                ...appliedFilters     // 🔥 preserve filters
            },
            search: searchTerm
        });
    };


    const handleFileUpload = (event, type, rowIndex) => {
        const files = event.target.files;

        if (files.length > 0) {
            setUploadedFiles(prevFiles => ({
                ...prevFiles,
                [rowIndex]: {
                    ...prevFiles[rowIndex],
                    [type]: [...(prevFiles[rowIndex]?.[type] || []), ...files]
                }
            }));
        }
    };

    const removeFile = (rowIndex, type) => {
        setUploadedFiles(prevFiles => {
            const updatedFiles = { ...prevFiles };
            if (updatedFiles[rowIndex]?.[type]) {
                delete updatedFiles[rowIndex][type]; // Remove file entry
            }
            return updatedFiles;
        });
    };

    const handleLimitChange = (e) => {
        const newLimit = Number(e.target.value);
        setLimit(newLimit);
        setCurrentPage(0);
        setSkip(0);

        const status = activeTab.toLowerCase();

        const payload = {
            limit: newLimit,
            skip: 0,
            type: 'sales',
            filter: {
                status: status,
            },
            search: searchTerm
        };
        fetchData(payload);
    };


    const handleDateSelection = (date) => {
        console.log("Selected Date:", date);
    };

    const navigate = useNavigate();

    const handleAddNewClick = () => {
        navigate("/invoice_addNew");
    };

    const closePopup = () => {
        setEditData(null);
        setIsPopupOpen(false);
    };

    const isAllSelected = selectedRows.length === tableData.length;
    const isAnySelected = selectedRows.length > 0;

    const handleSelectAll = () => {
        const newSelected = isAllSelected ? [] : tableData.map((row) => row.id);
        setSelectedRows(newSelected);

        const selectedInvoices = tableData.filter(row =>
            newSelected.includes(row.id)
        );
        // Show SAP button only if all selected are completed
        // setShowSapButton(newSelected.length > 0 && tableData.every(row =>
        //     newSelected.includes(row.id) && row.approval_status.toLowerCase() === "completed"
        // ));

        setShowBulkSubmitButton(newSelected.length > 0 && tableData.every(row =>
            newSelected.includes(row.id) && row.approval_status.toLowerCase() === "draft"
        ));

        const allSapPushed =
            newSelected.length > 0 &&
            selectedInvoices.every(
                inv => inv.approval_status.toLowerCase() === "sap pushed"
            );

        setShowSapBulkActions(allSapPushed);

        const allFinal =
            newSelected.length > 0 &&
            selectedInvoices.every(inv =>
                inv.approval_status.toLowerCase() === "final invoice"
            );
        setShowFinalBulkCancel(allFinal);
    };

    const handleRowSelect = (id) => {
        const newSelected = selectedRows.includes(id)
            ? selectedRows.filter((rowId) => rowId !== id)
            : [...selectedRows, id];

        setSelectedRows(newSelected);

        // Get all selected invoices
        const selectedInvoices = tableData.filter(row => newSelected.includes(row.id));

        // Show SAP button only if at least one selected is completed
        // and none are in invalid states
        // const hasCompleted = selectedInvoices.some(inv =>
        //     inv.approval_status.toLowerCase() === "completed"
        // );

        // const hasInvalid = selectedInvoices.some(inv =>
        //     !["completed"].includes(inv.approval_status.toLowerCase())
        // );

        // setShowSapButton(newSelected.length > 0 && hasCompleted && !hasInvalid);



        // Show Bulk Submit button only if at least one selected is draft
        // and none are in invalid states
        const hasDraft = selectedInvoices.some(inv =>
            inv.approval_status.toLowerCase() === "draft"
        );

        const hasDraftInvalid = selectedInvoices.some(inv =>
            !["draft"].includes(inv.approval_status.toLowerCase())
        );

        setShowBulkSubmitButton(newSelected.length > 0 && hasDraft && !hasDraftInvalid);

        const allSapPushed =
            newSelected.length > 0 &&
            selectedInvoices.every(
                inv => inv.approval_status.toLowerCase() === "sap pushed"
            );

        setShowSapBulkActions(allSapPushed);

        const allFinal =
            newSelected.length > 0 &&
            selectedInvoices.every(inv =>
                inv.approval_status.toLowerCase() === "final invoice"
            );
        setShowFinalBulkCancel(allFinal);
    };

    const handleDelete = (id) => {
        setDeleteId(id);
        setConfirmOpen(true);
    };

    const confirmDelete = async () => {
        if (!deleteId) return;

        try {

            const response = await axiosInstance.delete(
                `/invoice/delete/${deleteId}`
            );

            if (response.status === 200) {
                toast.success("Invoice deleted successfully!");
                setTableData((prevData) => prevData.filter((row) => row.id !== deleteId));
                setTotal((prevTotal) => prevTotal - 1);
                fetchData();
            } else {
                toast.error(`Failed to delete the invoice! ${response.statusText}`);
            }
        } catch (error) {
            console.error("Error:", error);
            toast.error("Something went wrong while deleting!");
        } finally {
            setConfirmOpen(false);
            setDeleteId(null);
        }
    };

    const cancelDelete = () => {
        setConfirmOpen(false);
        setDeleteId(null);
    };

    // Filter invoices based on active tab
    const filteredInvoices = tableData.filter(inv => {
        if (activeTab === "all") return true;
        // if (activeTab === "completed") return inv.approval_status === "Completed" || "completed";
        if (activeTab === "sap pushed") return inv.approval_status === "sap pushed";
        if (activeTab === "final invoice") return inv.approval_status === "final invoice";
        // if (activeTab === "submitted") return inv.approval_status === "submitted";
        if (activeTab === "submitted") return ["submitted", "approved", "cancel submitted"].includes(inv.approval_status);
        if (activeTab === "rejected") return inv.approval_status === "rejected";
        if (activeTab === "draft") return inv.approval_status === "draft";
        return true;
    });

    const createClickHandler = (invoice) => {
        return () => {
            const status = invoice.approval_status.toLowerCase();
            if (status === "submitted" || status === "draft" || status === "rejected") {
                navigate("/salesInvoiceViewPage", { state: { invoice } });
            }
        };
    };

    const handleSearch = async (searchValue) => {
        setSearchTerm(searchValue);

        setCurrentPage(0);
        setSkip(0);

        fetchData({
            skip: 0,
            limit,
            type: 'sales',
            filter: {
                status: activeTab.toLowerCase(),
                ...appliedFilters
            },
            search: searchValue
        });
    };


    const formatDate = (date) => {
        if (!date) return null;
        return date.toISOString().split("T")[0];
    };

    const handleApply = () => {
        const filters = {
            status: activeTab.toLowerCase(),
            inv_number: selectedInvoice && selectedInvoice.length > 0 ? selectedInvoice.map(v => v.value) : [],
            project: staticProject && staticProject.length > 0 ? staticProject.map(v => v.value) : [],
            plant_code: plantCode && plantCode.length > 0 ? plantCode.map(v => v.value) : [],
            from_date: fromDate ? formatDate(fromDate) : null,
            to_date: toDate ? formatDate(toDate) : null,
            sap_doc_no: sapDocNumber || null,
            profit_centre: profitCenter && profitCenter.length > 0 ? profitCenter.map(v => v.value) : [],
            city: city && city.length > 0 ? city.map(v => v.value) : [],
            state: state && state.length > 0 ? state.map(v => v.value) : [],
            zones: zone && zone.length > 0 ? zone.map(v => v.value) : [],
            division_type: divisionType || null
        };

        const { status, ...restFilters } = filters;

        const isEmpty = Object.values(restFilters).every(
            (val) => {
                if (Array.isArray(val)) {
                    return val.length === 0;
                }
                return val === null || val === "" || val === undefined;
            }
        );

        if (isEmpty) {
            toast.warning("Please select at least one filter before applying.");
            return;
        }

        setAppliedFilters(filters);

        setCurrentPage(0);
        setSkip(0);

        console.log("Applied Filters:", filters);

        fetchData({
            skip: 0,
            limit,
            type: "sales",
            filter: filters,
            search: searchTerm
        });
    };

    const handleClearFilters = () => {
        const isAlreadyEmpty =
            (!selectedInvoice || selectedInvoice.length === 0) &&
            !sapDocNumber &&
            (!staticProject || staticProject.length === 0) &&
            (!plantCode || plantCode.length === 0) &&
            !fromDate &&
            !toDate &&
            (!profitCenter || profitCenter.length === 0) &&
            (!city || city.length === 0) &&
            (!state || state.length === 0) &&
            (!zone || zone.length === 0) &&
            !divisionType ;

        if (isAlreadyEmpty) {
            toast.warning("No filters to reset.");
            return;
        }
        setProfitCenter([]);
        setCity([]);
        setState([]);
        setZone([]);
        setPlantCode([]);
        setSelectedInvoice([]);
        setSapDocNumber("");
        setStaticProject([]);
        setFilterDateRange([null, null]);
        setDivisionType("");
        setAppliedFilters({});
        setCurrentPage(0);
        setSkip(0);
        fetchAll();
    };

    const loadProjectOptions = async (inputValue) => {
        try {
            const res = await axiosInstance.get("/costsolution/projects/autosuggestion", {
                params: { term: inputValue || '' }
            }
            );

            const projects = res.data?.autosuggestion || [];

            if (openByArrow) {
                return projects.map(p => ({
                    label: p.label,
                    value: p.value
                }));
            }
            return projects.slice(0, 10).map(p => ({
                label: p.label,
                value: p.value
            }));
        } catch (error) {
            console.error("Project suggestion error:", error);
            return [];
        }
    };

    const loadInvoiceOptions = async (inputValue) => {
        try {
            const res = await axiosInstance.get("/invoice/getInvnumber", {
                params: { term: inputValue || "", invoice_type: "sales" }
            });

            const invoices = res.data?.autosuggestion || [];

            return invoices.map(inv => ({
                label: inv.label,
                value: inv.value
            }));
        } catch (error) {
            console.error("Invoice autosuggestion error:", error);
            return [];
        }
    };

    const handleBulkDeleteSubmit = async () => {
        const invoicesPayload = bulkDeleteInvoices.map(inv => ({
            invoice_id: inv.id,
            deleted_remarks: bulkDeleteRemarks[inv.id] || ""
        }));

        const hasEmptyRemark = invoicesPayload.some(
            i => !i.deleted_remarks.trim()
        );

        if (hasEmptyRemark) {
            toast.error("Delete remarks required for all invoices");
            return;
        }

        try {
            const res = await axiosInstance.post(
                "/invoice/sappushed_bulkdelete",
                { invoices: invoicesPayload }
            );

            if (res.data?.success) {
                toast.success("SAP pushed invoices deleted successfully");
                setIsBulkDeleteOpen(false);
                setSelectedRows([]);
                setShowSapBulkActions(false);

                fetchData({
                    skip: 0,
                    limit,
                    type: "sales",
                    filter: { status: "sap pushed" }
                });
            } else {
                toast.error(res.data?.message || "Bulk delete failed");
            }
        } catch (err) {
            console.error("Bulk delete error", err);
            toast.error("Bulk delete failed");
        }
    };

    const handleInvoiceBulkCancelSubmit = async () => {
        if (selectedRows.length === 0) {
            toast.error("No invoices selected");
            return;
        }

        if (remarkToCustomer === null) {
            toast.error("Please choose a cancellation method.");
            return;
        }

        const invoicesPayload = selectedRows.map(id => ({
            invoice_id: id,
            cancel_reason: invoiceComments[id] || globalCancelRemark || ""
        }));

        const hasEmptyReason = invoicesPayload.some(
            inv => !inv.cancel_reason.trim()
        );

        if (hasEmptyReason) {
            setCommentError("Cancellation reason is required for all invoices");
            return;
        }

        try {
            const payload = {
                new_invoice_creation: remarkToCustomer === true,
                comments: globalCancelRemark || "",
                invoices: invoicesPayload
            };

            const response = await axiosInstance.post(
                "/invoice/inv_bulk_cancel",
                payload
            );

            if (response.data?.success) {
                toast.success(response.data?.message);
                setSelectedRows([]);
                setShowSapBulkActions(false);
                closeBulkCancelModal();
                setInvoiceComments({});
                setGlobalCancelRemark("");
                setRemarkToCustomer(null);

                fetchData({
                    skip: 0,
                    limit,
                    type: "sales",
                    filter: { status: "sap pushed" }
                });
            } else {
                toast.error(response.data?.message || "Bulk cancel failed");
            }
        } catch (error) {
            console.error("Bulk cancel error:", error);
            toast.error(error.response?.data?.message || "Bulk cancel failed");
        }
    };

    const closeBulkCancelModal = () => {
        setIsBulkCancelModalOpen(false);
        setComment("");
        setCommentError("");
    };

    const handleToggleRadio = (value) => {
        setInvoiceCancelAction((prev) => (prev === value ? "" : value));
    };

    const handleBulkModificationSubmit = async () => {
        const invoicesPayload = selectedRows.map(id => ({
            invoice_id: id,
            modification_reason: bulkRemarks[id] || ""
        }));

        // Optional validation
        const hasEmptyRemark = invoicesPayload.some(
            inv => !inv.modification_reason.trim()
        );

        if (hasEmptyRemark) {
            toast.error("Please enter remarks for all invoices");
            return;
        }

        try {
            const response = await axiosInstance.post(
                "/invoice/inv_bulk_modify",
                { invoices: invoicesPayload }
            );

            if (response.data?.success) {
                toast.success(response.data?.message);
                setIsBulkModificationOpen(false);
                setBulkRemarks({});
                setSelectedRows([]);
                fetchData(); // refresh table
            } else {
                toast.error(response.data?.message || "Bulk modification failed");
            }
        } catch (error) {
            console.error("Bulk modification error:", error);
            toast.error("Something went wrong");
        }
    };

    const handleBulkModificationOpen = async () => {
        if (selectedRows.length === 0) {
            toast.error("No invoices selected");
            return;
        }

        try {
            const response = await axiosInstance.post(
                "/invoice/inv_bulk_choose",
                {
                    invoice_ids: selectedRows
                }
            );

            if (response.data?.success) {
                setBulkModificationInvoices(response.data.data); // backend invoices
                setBulkRemarks({});
                setIsBulkModificationOpen(true);
            } else {
                toast.error(response.data?.message || "Failed to fetch invoices");
            }
        } catch (error) {
            console.error("Bulk choose error:", error);
            toast.error("Something went wrong");
        }
    };

    const handleBulkDeletionOpen = async () => {
        if (selectedRows.length === 0) {
            toast.error("No invoices selected");
            return;
        }

        try {
            const response = await axiosInstance.post(
                "/invoice/inv_bulk_choose",
                {
                    invoice_ids: selectedRows
                }
            );

            if (response.data?.success) {
                setBulkDeleteInvoices(response.data.data);
                setBulkDeleteRemarks({});
                setIsBulkDeleteOpen(true);
            } else {
                toast.error(response.data?.message || "Failed to fetch invoices");
            }
        } catch (error) {
            console.error("Bulk choose error:", error);
            toast.error("Something went wrong");
        }
    };

    const handleBulkCancelOpen = async () => {
        if (selectedRows.length === 0) {
            toast.error("No invoices selected");
            return;
        }

        try {
            const response = await axiosInstance.post(
                "/invoice/inv_bulk_choose",
                {
                    invoice_ids: selectedRows
                }
            );

            if (response.data?.success) {
                // reuse the same invoices list
                setBulkModificationInvoices(response.data.data);

                // reset cancel-specific states
                setInvoiceComments({});
                setGlobalCancelRemark("");
                setRemarkToCustomer(null);
                setCommentError("");

                // open cancel modal
                setIsBulkCancelModalOpen(true);
            } else {
                toast.error(response.data?.message || "Failed to fetch invoices");
            }
        } catch (error) {
            console.error("Bulk cancel choose error:", error);
            toast.error("Something went wrong");
        }
    };

    const fetchApprovalData = async (invoiceId) => {
        try {
            const response = await axiosInstance.post('/invoice/inv_approval_data', {
                invoice_id: invoiceId
            });

            if (response.data?.success) {
                return response.data.data;
            } else {
                toast.error(response.data?.message || "Failed to fetch approval data");
                return null;
            }
        } catch (error) {
            console.error("Approval data error:", error);
            toast.error("Error fetching approval data");
            return null;
        }
    };

    const formatStatus = (status) => {
        if (!status) return "";
        return status
            .toLowerCase()
            .split(" ")
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" ");
    };

    return (
        <>
            <Invoice_header onSearch={handleSearch} />
            <div className="container">
                <div className="invoice-header">
                    <div className="invoice-left-header">

                        <button
                            className={`invoice-btn invoice-all-btn ${activeTab === "all" ? "active" : ""}`}
                            onClick={() => setActiveTab("all")}
                        >
                            All{activeTab === "all" && ``}
                        </button>


                        <button
                            className={`invoice-btn invoice-draft-btn ${activeTab === "draft" ? "active" : ""}`}
                            onClick={() => setActiveTab("draft")}
                        >
                            Draft{activeTab === "draft" && ``}
                        </button>


                        <AdditionalPermissionWrapper permissionKey="submitted_sales_invoice" moduleId={ModuleId}>
                            <button
                                className={`invoice-btn invoice-submitted-btn ${activeTab === "submitted" ? "active" : ""}`}
                                onClick={() => setActiveTab("submitted")}
                            >
                                Submitted{activeTab === "submitted" && ``}
                            </button>
                        </AdditionalPermissionWrapper>


                        <AdditionalPermissionWrapper permissionKey="rejected_sales_invoice" moduleId={ModuleId}>
                            <button
                                className={`invoice-btn invoice-rejected-btn ${activeTab === "rejected" ? "active" : ""}`}
                                onClick={() => setActiveTab("rejected")}
                            >
                                Rejected{activeTab === "rejected" && ``}
                            </button>
                        </AdditionalPermissionWrapper>


                        {/* <AdditionalPermissionWrapper permissionKey="completed" moduleId={ModuleId}>
                            <button
                                className={`invoice-btn invoice-completed-btn ${activeTab === "completed" ? "active" : ""}`}
                                onClick={() => setActiveTab("completed")}
                            >
                                Completed{activeTab === "completed" && `(${statusCounts.completed})`}
                            </button>
                        </AdditionalPermissionWrapper> */}


                        <AdditionalPermissionWrapper permissionKey="sap_pushed_sales_invoice" moduleId={ModuleId}>
                            <button
                                className={`invoice-btn invoice-completed-btn ${activeTab === "sap pushed" ? "active" : ""}`}
                                onClick={() => setActiveTab("sap pushed")}
                            >
                                SAP Pushed{activeTab === "sap pushed" && ``}
                            </button>
                        </AdditionalPermissionWrapper>


                        <AdditionalPermissionWrapper permissionKey="final_sales_invoice" moduleId={ModuleId}>
                            <button
                                className={`invoice-btn invoice-final-btn ${activeTab === "final invoice" ? "active" : ""}`}
                                onClick={() => setActiveTab("final invoice")}
                            >
                                Final Invoice{activeTab === "final invoice" && ``}
                            </button>
                        </AdditionalPermissionWrapper>

                        <button
                            className={`invoice-btn invoice-final-btn ${activeTab === "cancelled" ? "active" : ""}`}
                            onClick={() => setActiveTab("cancelled")}
                        >
                            Cancelled{activeTab === "cancelled" && ``}
                        </button>

                        <AdditionalPermissionWrapper permissionKey="deleted_sales_invoice" moduleId={ModuleId}>
                            <button
                                className={`invoice-btn invoice-final-btn ${activeTab === "deleted" ? "active" : ""}`}
                                onClick={() => setActiveTab("deleted")}
                            >
                                Deleted{activeTab === "deleted" && ``}
                            </button>
                        </AdditionalPermissionWrapper>

                    </div>
                    <div className="right-header">
                        {showSapButton && (
                            <button
                                className="sap-push-btn"
                                onClick={handleSapPush}
                                style={{
                                    backgroundColor: '#008B1F',
                                    color: 'white',
                                    padding: '8px 16px',
                                    border: 'none',
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                    marginLeft: '10px',
                                    height: '36px',
                                    fontWeight: '600',
                                    fontSize: '14px',
                                    cursor: 'pointer'
                                }}
                            >
                                SAP Push
                            </button>
                        )}

                        <div
                            className={`project-popup-filter-setshow-image ${showFilter ? "active" : ""}`}
                            onClick={() => setShowFilter(!showFilter)}
                        >
                            <img
                                src={filterOpenCloseIcon}
                                alt="Filter"
                                className="project-popup-filter-icon"
                                title={showFilter ? "Hide Filters" : "Show Filters"}
                            />
                        </div>


                        {/* {!isAnySelected && (
                        <>
                            <DatePicker onDateChange={handleDateSelection} />
                            <h4>Sort by :</h4>
                            <div className="dropdown">
                                <select id="options" className="dropdown-select">
                                    <option value="option1">Date Created</option>
                                    <option value="option2">Option 2</option>
                                    <option value="option3">Option 3</option>
                                </select>
                            </div>
                        </>
                    )} */}
                    </div>
                </div>

                <div className={`filteropenclose-wrapper ${showFilter ? "open" : ""}`}>
                    <SalesInvoiceFilter
                        showFilters={showFilters}
                        setShowFilters={setShowFilters}
                        loadInvoiceOptions={loadInvoiceOptions}
                        loadProjectOptions={loadProjectOptions}
                        selectedInvoice={selectedInvoice}
                        setSelectedInvoice={setSelectedInvoice}
                        staticProject={staticProject}
                        setStaticProject={setStaticProject}
                        sapDocNumber={sapDocNumber}
                        setSapDocNumber={setSapDocNumber}
                        fromDate={fromDate}
                        toDate={toDate}
                        setFilterDateRange={setFilterDateRange}
                        appliedFilters={appliedFilters}
                        setAppliedFilters={setAppliedFilters}
                        fetchData={fetchData}
                        limit={limit}
                        searchTerm={searchTerm}
                        activeTab={activeTab}
                        handleApply={handleApply}
                        handleClearFilters={handleClearFilters}
                        setOpenByArrow={setOpenByArrow}
                        profitCenter={profitCenter}
                        setProfitCenter={setProfitCenter}
                        city={city}
                        setCity={setCity}
                        state={state}
                        setState={setState}
                        zone={zone}
                        setZone={setZone}
                        plantCode={plantCode}
                        setPlantCode={setPlantCode}
                        divisionType={divisionType}
                        setDivisionType={setDivisionType}
                    />
                </div>

                <div className="table-top-actions"
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: '0px'
                    }}
                >
                    <div style={{ display: "flex", alignItems: "center" }}>
                        <span className="records-pill">
                            Total Records:
                            <span className="records-pill-sales">{total}</span>
                        </span>

                        {selectedRows.length > 0 &&
                            (activeTab === "draft" ||
                                activeTab === "sap pushed" ||
                                activeTab === "final invoice") && (
                                <>
                                    <span className="sc-summary-separator">-</span>
                                    <span className="sc-summary-hint" style={{ fontSize: "13px", color: "#667085" }}>
                                        {selectedRows.length}{" "}
                                        {activeTab === "draft"
                                            ? "Draft invoice selected"
                                            : activeTab === "sap pushed"
                                                ? "SAP invoice selected"
                                                : "Final invoice selected"}
                                    </span>
                                </>
                            )}
                    </div>

                    <div style={{ display: "flex", gap: "8px" }}>
                        {activeTab === "draft" && showBulkSubmitButton && (
                            <button
                                className="sap-push-btn"
                                onClick={handleBulkSubmit}
                                style={{
                                    backgroundColor: "#008B1F",
                                    color: "#fff",
                                    padding: "8px 16px",
                                    borderRadius: "6px",
                                    fontWeight: 600,
                                    border: "none",
                                    cursor: "pointer",
                                    height: '40px',
                                    marginRight: '10px'
                                }}
                            >
                                Bulk Submit
                            </button>
                        )}

                        {activeTab === "sap pushed" && showSapBulkActions && (
                            <>
                                <button className="sap-push-btn"
                                    style={{
                                        backgroundColor: "#19324C",
                                        color: "#fff",
                                        padding: "8px 16px",
                                        borderRadius: "6px",
                                        fontWeight: 600,
                                        border: "none",
                                        height: "40px",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "8px",
                                        cursor: "pointer",
                                    }}
                                    onClick={handleBulkModificationOpen}
                                >
                                    <FaEdit />
                                    <span>Bulk Modification</span>
                                </button>
                                <button
                                    className="sap-push-btn"
                                    style={{
                                        backgroundColor: "#F59E0B",
                                        color: "#fff",
                                        padding: "8px 16px",
                                        borderRadius: "6px",
                                        fontWeight: 600,
                                        border: "none",
                                        height: "40px",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "8px",
                                        cursor: "pointer",
                                    }}
                                    onClick={handleBulkCancelOpen}
                                >
                                    <span
                                        style={{
                                            width: "16px",
                                            height: "16px",
                                            backgroundColor: "#ffffff",
                                            color: "#F59E0B",
                                            borderRadius: "50%",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            fontSize: "14px",
                                            fontWeight: 700,
                                            lineHeight: "1",
                                        }}
                                    >
                                        ×
                                    </span>

                                    Bulk Cancel
                                </button>

                                <AdditionalPermissionWrapper permissionKey="deleted_sales_invoice" moduleId={ModuleId}>
                                    <button className="sap-push-btn"
                                        style={{
                                            backgroundColor: "#FF4444",
                                            color: "#fff",
                                            padding: "8px 16px",
                                            borderRadius: "6px",
                                            fontWeight: 600,
                                            border: "none",
                                            height: "40px",
                                            marginRight: "10px",
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "8px",
                                            cursor: "pointer",
                                        }}
                                        onClick={handleBulkDeletionOpen}
                                    >
                                        <img
                                            src={BulkDeleteIcon}
                                            alt="Delete"
                                            style={{
                                                width: "16px",
                                                height: "16px",
                                                display: "block",
                                            }}
                                        />
                                        <span>Bulk Delete</span>
                                    </button>
                                </AdditionalPermissionWrapper>
                            </>
                        )}

                        {activeTab === "final invoice" && showFinalBulkCancel && (
                            <>
                                <button className="sap-push-btn"
                                    style={{
                                        backgroundColor: "#19324C",
                                        color: "#fff",
                                        padding: "8px 16px",
                                        borderRadius: "6px",
                                        fontWeight: 600,
                                        border: "none",
                                        height: "40px",
                                        marginRight: "10px",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "8px",
                                        cursor: "pointer",
                                    }}
                                    onClick={handleBulkModificationOpen}

                                >
                                    <FaEdit />
                                    <span>Bulk Modification</span>
                                </button>
                                <button
                                    className="sap-push-btn"
                                    style={{
                                        backgroundColor: "#DC2626",
                                        color: "#fff",
                                        padding: "8px 16px",
                                        borderRadius: "6px",
                                        fontWeight: 600,
                                        border: "none",
                                        height: "40px",
                                        marginRight: "10px",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "8px",
                                        cursor: "pointer",
                                    }}
                                    onClick={handleBulkCancelOpen}
                                >
                                    <span
                                        style={{
                                            width: "16px",
                                            height: "16px",
                                            backgroundColor: "#ffffff",
                                            color: "#DC2626",
                                            borderRadius: "50%",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            fontSize: "14px",
                                            fontWeight: 700,
                                            lineHeight: "1",
                                        }}
                                    >
                                        ×
                                    </span>
                                    <span>Bulk Cancel</span>
                                </button>
                            </>
                        )}
                    </div>
                </div>

                <div className='invoice-table' style={{ overflowX: 'auto', whiteSpace: 'nowrap', scrollbarWidth: 'none', OverflowStyle: 'none', WebkitOverflowScrolling: 'touch', scrollBehavior: 'smooth' }}>
                    <table>
                        <thead>
                            <tr>
                                <th style={{
                                    width: "60px",
                                    minWidth: "60px",
                                    textAlign: "center",
                                    padding: "4px"
                                }}>
                                    <input
                                        type="checkbox"
                                        checked={isAllSelected}
                                        onChange={handleSelectAll}
                                    />
                                </th>
                                <th>Invoice No</th>
                                <th>Supply Period</th>
                                <th>Project</th>
                                <th>Division Type</th>
                                {(activeTab === "final invoice" || activeTab === "all") && (
                                    <th>SAP Doc No.</th>
                                )}
                                <th>Quantity</th>
                                <th>Rate</th>
                                <th>Total</th>

                                <th>Current status</th>
                                <th>Next status</th>

                                <th></th>
                                {activeTab == "sap pushed" && (
                                    <th></th>
                                )}

                                {activeTab == "final invoice" && (
                                    <th></th>
                                )}


                            </tr>
                        </thead>
                        <tbody>
                            {filteredInvoices.length > 0 ? (
                                filteredInvoices.map((invoice, index) => {
                                    const status = invoice.approval_status.toLowerCase();
                                    const isDraft = status === "draft" || status === "rejected";
                                    const isViewable = ["submitted", "rejected", "re-submitted", "sap pushed", "final invoice", "cancelled", "deleted", "approved", "cancel submitted"].includes(status);
                                    const rowClass = isViewable ? "clickable-row" : "";
                                    const rowStyle = isViewable ? { cursor: "pointer" } : { cursor: "default" };

                                    const handleRowClick = (e) => {
                                        if (!permission || permission.view_permission !== "1") {
                                            return;
                                        }

                                        // Ignore clicks that come from checkboxes or their labels
                                        if (e.target.tagName === 'INPUT' && e.target.type === 'checkbox') {
                                            return;
                                        }

                                        if (isViewable) {
                                            if (status === "cancelled") {
                                                navigate("/salesInvoiceViewPage", {
                                                    state: {
                                                        invoice,
                                                        isCancelledInvoice: true
                                                    }
                                                });
                                            } else {
                                                navigate("/salesInvoiceViewPage", { state: { invoice } });
                                            }
                                        }
                                    };

                                    return (
                                        <tr key={index} className={rowClass} style={rowStyle} onClick={handleRowClick} onMouseEnter={() => setIsHovered(invoice.id)}
                                            onMouseLeave={() => setIsHovered(null)}>
                                            <td onClick={(e) => e.stopPropagation()}>
                                                <input
                                                    style={{
                                                        width: "60px",
                                                        minWidth: "60px",
                                                        textAlign: "center",
                                                        padding: "4px"
                                                    }}
                                                    type="checkbox"
                                                    checked={selectedRows.includes(invoice.id)}
                                                    onChange={(e) => {
                                                        e.stopPropagation();
                                                        handleRowSelect(invoice.id);
                                                    }}
                                                    onClick={(e) => e.stopPropagation()} // Add this
                                                />
                                            </td>
                                            <td>
                                                <div className="inv-manual-automation-wrapper">
                                                    <span
                                                        title={
                                                            invoice.billing_automation_id
                                                                ? "Automation"
                                                                : "Manual"
                                                        }
                                                        className={`inv-manual-automation-circle ${invoice.billing_automation_id
                                                                ? "inv-manual-automation-auto"
                                                                : "inv-manual-automation-manual"
                                                            }`}
                                                    >
                                                        <span className="inv-manual-automation-text">
                                                            {invoice.billing_automation_id ? "A" : "M"}
                                                        </span>
                                                    </span>
                                                    <span className="inv-manual-automation-separator"></span>
                                                    <span>{invoice.inv_number}</span>
                                                </div>
                                            </td>
                                            <td>
                                                {invoice?.supply_period ? (
                                                    <span className="supply-period-pill">
                                                        <svg viewBox="0 0 24 24" fill="currentColor">
                                                            <path d="M7 2a1 1 0 0 1 1 1v1h8V3a1 1 0 1 1 2 0v1h1a3 3 0 0 1 3 3v11a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h1V3a1 1 0 0 1 1-1zm12 8H5v8a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-8z" />
                                                        </svg>
                                                        {invoice.supply_period}
                                                    </span>
                                                ) : null}
                                            </td>
                                            <td>{invoice.project}</td>
                                            <td style={{ textAlign: 'center' }}>{invoice.division_type?.toUpperCase() || "--"}</td>
                                            {(activeTab === "final invoice" || activeTab === "all") && (
                                                <td style={{ textAlign: 'center' }}>{invoice.sap_doc_no || "--"}</td>
                                            )}
                                            <td>{invoice.inv_quantity}</td>
                                            <td>{invoice.inv_rate}</td>
                                            <td>{invoice.inv_amount}</td>

                                            <td>
                                                <button className={`invoice-status-button ${status}`}>
                                                    {formatStatus(invoice.approval_status)}
                                                </button>
                                            </td>
                                            <td>{invoice.next_status}</td>

                                            {activeTab == "sap pushed" && (
                                                <td>
                                                    <div className='invoice-csv-file-downloads'
                                                        style={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                            gap: "6px",
                                                            padding: "6px 12px",
                                                            borderRadius: "9999px", // Full pill shape
                                                            border: "1px solid #ccc",
                                                            cursor: "pointer",
                                                            fontWeight: "500",
                                                            width: "fit-content",
                                                            userSelect: "none"
                                                        }}
                                                        onClick={async (e) => {
                                                            e.stopPropagation();
                                                            try {
                                                                const response = await axiosInstance.post(`/sales_csv_generate/${invoice.id}`);
                                                                console.log("response", response);
                                                                const fileUrl = response?.data?.file_url;

                                                                if (fileUrl) {
                                                                    const fileName = fileUrl.split('/').pop(); // Extracts 'SI20250627007_variable.csv'
                                                                    // This avoids CORS issues — triggers a direct browser download
                                                                    const link = document.createElement('a');
                                                                    link.href = fileUrl;
                                                                    // link.setAttribute('download', `invoice_${invoice.id}.csv`);
                                                                    link.setAttribute('download', fileName);
                                                                    document.body.appendChild(link);
                                                                    link.click();
                                                                    document.body.removeChild(link);
                                                                } else {
                                                                    alert("File URL not found.");
                                                                }
                                                            } catch (error) {
                                                                console.error("Download failed:", error);
                                                                alert("Failed to download sales invoice file.");
                                                            }
                                                        }}
                                                    >
                                                        <img
                                                            src={download_arrow}
                                                            alt="Download"
                                                            className="downloads_icon"
                                                            style={{ width: "16px", height: "16px" }}
                                                        />
                                                        <span>CSV</span>
                                                    </div>
                                                </td>
                                            )}

                                            {activeTab == "final invoice" && (
                                                <>
                                                    <td>
                                                        <div className='invoice-csv-file-downloads'
                                                            style={{
                                                                display: "flex",
                                                                alignItems: "center",
                                                                gap: "6px",
                                                                padding: "6px 12px",

                                                                borderRadius: "9999px",
                                                                border: "1px solid #ccc",
                                                                cursor: "pointer",
                                                                fontWeight: "500",
                                                                width: "fit-content",

                                                            }}
                                                            onClick={async (e) => {
                                                                e.stopPropagation();
                                                                try {
                                                                    const response = await axiosInstance.post(`/sales_csv_generate/${invoice.id}`);
                                                                    const fileUrl = response?.data?.file_url;

                                                                    if (fileUrl) {
                                                                        const fileName = fileUrl.split('/').pop();
                                                                        const link = document.createElement('a');
                                                                        link.href = fileUrl;
                                                                        // link.setAttribute('download', `invoice_${invoice.id}.csv`);
                                                                        link.setAttribute('download', fileName);
                                                                        document.body.appendChild(link);
                                                                        link.click();
                                                                        document.body.removeChild(link);
                                                                    } else {
                                                                        alert("File URL not found.");
                                                                    }
                                                                } catch (error) {
                                                                    console.error("Download failed:", error);
                                                                    alert("Failed to download invoice file.");
                                                                }
                                                            }}
                                                        >
                                                            <img
                                                                src={download_arrow}
                                                                alt="Download"
                                                                className="downloads_icon"
                                                                style={{ width: "16px", height: "16px" }}
                                                            />
                                                            <span>CSV</span>
                                                        </div>
                                                    </td>

                                                    <td>
                                                        <div className='invoice-inv-file-downloads'
                                                            style={{
                                                                display: "flex",
                                                                alignItems: "center",
                                                                gap: "6px",
                                                                padding: "6px 12px",
                                                                borderRadius: "9999px", // Full pill shape
                                                                border: "1px solid #ccc",
                                                                cursor: "pointer",
                                                                fontWeight: "500",
                                                                width: "fit-content",
                                                                userSelect: "none"
                                                            }}
                                                            onClick={async (e) => {
                                                                e.stopPropagation();
                                                                try {
                                                                    const response = await axiosInstance.post(`/final_invoice_file/${invoice.id}`);
                                                                    console.log("final invoice response", response);
                                                                    const fileUrl = response?.data?.file_url;

                                                                    if (fileUrl) {
                                                                        // This avoids CORS issues — triggers a direct browser download
                                                                        const link = document.createElement('a');
                                                                        link.href = fileUrl;
                                                                        // link.setAttribute('download', `invoice_${invoice.id}.csv`);
                                                                        const fileExtension = fileUrl.split('.').pop().toLowerCase();
                                                                        link.setAttribute('download', `invoice_${invoice.id}.${fileExtension}`);
                                                                        document.body.appendChild(link);
                                                                        link.click();
                                                                        document.body.removeChild(link);
                                                                    } else {
                                                                        alert("File URL not found.");
                                                                    }
                                                                } catch (error) {
                                                                    console.error("Download failed:", error);
                                                                    alert("Failed to download invoice file.");
                                                                }
                                                            }}>
                                                            <img
                                                                src={download_arrow}
                                                                alt="Download"
                                                                className="downloads_icon"
                                                                style={{ width: "16px", height: "16px" }}
                                                            />
                                                            <span>INV</span>
                                                        </div>
                                                    </td>

                                                </>
                                            )}

                                            <td>
                                                {isDraft && (
                                                    <div className="actions" onClick={(e) => e.stopPropagation()}>

                                                        <PermissionWrapper permissionKey="edit_permission" moduleId={ModuleId}>
                                                            <span className="edit-icon" style={{ cursor: "pointer" }}>
                                                                <img
                                                                    src={Vector}
                                                                    onClick={createClickHandler(invoice)}
                                                                    alt="Edit Icon"
                                                                    width="20"
                                                                    height="20"
                                                                />
                                                            </span>
                                                        </PermissionWrapper>


                                                        <PermissionWrapper permissionKey="delete_permission" moduleId={ModuleId}>
                                                            <span className="delete-icon">
                                                                <img src={Delete} alt="Delete Icon" width="40" height="40" onClick={() => handleDelete(invoice.id)} />
                                                            </span>
                                                        </PermissionWrapper>
                                                    </div>

                                                )}

                                                {(invoice.show_button && isHovered === invoice.id) && (
                                                    <div
                                                        className="action-icons"
                                                        style={{
                                                            display: 'flex',
                                                            gap: '10px',
                                                        }}
                                                    >
                                                        <button
                                                            className="ticket-icon"
                                                            title="Approve Invoice"
                                                            style={{
                                                                width: '24px',
                                                                height: '24px',
                                                                borderRadius: '50%',
                                                                backgroundColor: '#f0f0f0',
                                                                border: 'none',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                cursor: 'pointer'
                                                            }}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                            }}
                                                        >
                                                            <img
                                                                style={{ width: '20px', height: '20px' }}
                                                                onClick={async () => {
                                                                    const data = await fetchApprovalData(invoice.id);

                                                                    if (data) {
                                                                        setActiveInvoice({
                                                                            ...invoice,
                                                                            approvalData: data
                                                                        });
                                                                        setActionType('approved');
                                                                        setModalOpen(true);
                                                                    }
                                                                }}
                                                                src={checked_icon}
                                                            />

                                                        </button>
                                                        <button
                                                            className="remove-icon"
                                                            title="Reject Invoice"
                                                            style={{
                                                                width: '24px',
                                                                height: '24px',
                                                                borderRadius: '50%',
                                                                backgroundColor: '#f0f0f0',
                                                                border: 'none',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                cursor: 'pointer'
                                                            }}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                            }}
                                                        >
                                                            <img
                                                                style={{ width: '20px', height: '20px' }}
                                                                onClick={async () => {
                                                                    const data = await fetchApprovalData(invoice.id);

                                                                    if (data) {
                                                                        setActiveInvoice({
                                                                            ...invoice,
                                                                            approvalData: data
                                                                        });
                                                                        setActionType('rejected');
                                                                        setModalOpen(true);
                                                                    }
                                                                }}
                                                                src={removed_icon}
                                                                alt=''
                                                            />
                                                        </button>

                                                    </div>
                                                )}
                                            </td>


                                        </tr>
                                    );
                                })) : (
                                <tr>
                                    {searchTerm && filteredInvoices.length === 0 && (
                                        <td colSpan="7" style={{ textAlign: 'center', padding: '20px', fontSize: '14px', color: '#666' }}>
                                            No Sales Invoice found matching "{searchTerm}"
                                        </td>
                                    )}
                                </tr>
                            )
                            }
                        </tbody>
                    </table>
                </div>

                {/* Pagination Controls */}
                <CommonPagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    limit={limit}
                    onPageChange={handlePageClick}
                    onLimitChange={handleLimitChange}
                />
            </div >
            <ConfirmDialog
                open={confirmBulkSubmitOpen}
                title="Bulk Submit Invoices"
                message={`Are you sure you want to submit ${selectedRows.length} selected invoices?`}
                confirmText="Submit"
                cancelText="Cancel"
                onConfirm={confirmBulkSubmit}
                onCancel={cancelBulkSubmit}
            />
            <ConfirmDialog
                open={confirmOpen}
                title="Delete Confirmation"
                message="Are you sure you want to delete this Invoice?"
                confirmText="Delete"
                cancelText="Cancel"
                onConfirm={confirmDelete}
                onCancel={cancelDelete}
            />
            <CommonFooter />
            {isModalOpen && activeInvoice && (
                <ApproveRejectPopup
                    isOpen={isModalOpen}
                    onClose={closeModal}
                    actionType={actionType}
                    invoice={activeInvoice}
                    onSubmit={(data) =>
                        handleInvoiceAction(activeInvoice.id, activeInvoice.project_id, data)
                    }
                    isLoading={isApproveLoading}
                />
            )}
            {isBulkCancelModalOpen && (
                <div className="modification-modal popup-bulk-modification" onClick={closeBulkCancelModal}>
                    <div className="popup-bulk-modification-container" onClick={(e) => e.stopPropagation()}>
                        <div className="popup-bulk-modification-header">
                            <h3> Bulk Cancellation</h3>
                        </div>

                        <div className="popup-bulk-modification-body">
                            <div className="global-cancellation-row">
                                <div className="global-cancellation-remarks">
                                    <label className="global-cancellation-label">
                                        Global Cancellation Remarks
                                    </label>

                                    <div className="bulk-input-wrapper input-with-clear">
                                        <input
                                            type="text"
                                            maxLength={256}
                                            className="global-cancellation-input"
                                            placeholder="Enter global remarks"
                                            value={globalCancelRemark}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                setGlobalCancelRemark(value);

                                                const updated = {};
                                                selectedInvoices.forEach(inv => {
                                                    updated[inv.id] = value;
                                                });
                                                setInvoiceComments(updated);

                                                setCommentError("");
                                            }}
                                            style={{ margin: "0px" }}
                                        />

                                        {globalCancelRemark && (
                                            <span
                                                className="input-clear-icon"
                                                onClick={() => {
                                                    setGlobalCancelRemark("");
                                                    setInvoiceComments({});
                                                }}
                                                style={{ cursor: "pointer" }}
                                            >
                                                ×
                                            </span>
                                        )}

                                        <span className="bulk-counter">
                                            {globalCancelRemark.length}/256
                                        </span>
                                    </div>
                                </div>

                                <div className="global-cancellation-radio">
                                    <label className="global-cancellation-label">
                                        Cancel invoice and create a new one<span style={{ color: 'red' }}>*</span>
                                    </label>

                                    <div className="global-cancellation-radio-group" >
                                        <label className="global-cancellation-radio-option" style={{ margin: '0px' }}>
                                            <input
                                                type="radio"
                                                name="globalRemark"
                                                value="true"
                                                checked={remarkToCustomer === true}
                                                onChange={() => setRemarkToCustomer(true)}
                                                className="global-cancellation-radio-input"
                                            />
                                            <span className="global-cancellation-radio-custom"></span>
                                            <span className="global-cancellation-radio-text">Yes</span>
                                        </label>

                                        <label className="global-cancellation-radio-option" style={{ margin: '0px' }}>
                                            <input
                                                type="radio"
                                                name="globalRemark"
                                                value="false"
                                                checked={remarkToCustomer === false}
                                                onChange={() => setRemarkToCustomer(false)}
                                                className="global-cancellation-radio-input"
                                            />
                                            <span className="global-cancellation-radio-custom"></span>
                                            <span className="global-cancellation-radio-text">No</span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                            {selectedInvoices.map((inv) => (
                                <div className="bulk-modification-row" key={inv.id}>
                                    <div className="bulk-left">
                                        <p className="bulk-title">{inv.inv_number}</p>
                                        <p className="bulk-sub">
                                            Status : <span>{inv.approval_status}</span>
                                        </p>
                                    </div>

                                    <div className="bulk-divider"></div>

                                    <div className="bulk-right">
                                        <label className="bulk-label">
                                            Cancellation Reason
                                        </label>

                                        <div className="bulk-input-wrapper">
                                            <input
                                                type="text"
                                                value={invoiceComments[inv.id] || ""}
                                                maxLength={256}
                                                placeholder="Enter cancellation reason (max 256 characters)"
                                                onChange={(e) => {
                                                    setInvoiceComments(prev => ({
                                                        ...prev,
                                                        [inv.id]: e.target.value
                                                    }));
                                                    setCommentError("");
                                                }}
                                                style={{ margin: '0px' }}
                                            />

                                            <span className="bulk-counter">
                                                {(invoiceComments[inv.id] || "").length}/256
                                            </span>
                                        </div>

                                        {commentError && (
                                            <div className="error-msg" style={{ margin: '0px' }}>{commentError}</div>
                                        )}

                                    </div>
                                </div>
                            ))}
                        </div>

                        {/* Footer */}
                        <div className="popup-bulk-modification-footer">
                            <button onClick={closeBulkCancelModal}>Cancel</button>
                            <button onClick={handleInvoiceBulkCancelSubmit}>Submit</button>
                        </div>
                    </div>
                </div >
            )}
            {isBulkModificationOpen && (
                <div
                    className="modification-modal popup-bulk-modification"
                    onClick={() => setIsBulkModificationOpen(false)}
                >
                    <div
                        className="popup-bulk-modification-container"
                        onClick={(e) => e.stopPropagation()}
                    >

                        <div className="popup-bulk-modification-header">
                            <h3>
                                Bulk Modification
                            </h3>
                        </div>

                        <div className="popup-bulk-modification-body">
                            {bulkModificationInvoices.map((inv) => (
                                <div className="bulk-modification-row" key={inv.id}>
                                    <div className="bulk-left">
                                        <p className="bulk-title">{inv.inv_number}</p>
                                        <p className="bulk-sub">
                                            Status : <span>{inv.approval_status}</span>
                                        </p>
                                    </div>

                                    <div className="bulk-divider"></div>

                                    <div className="bulk-right">
                                        <label className="bulk-label">Remarks</label>

                                        <div className="bulk-input-wrapper">
                                            <input
                                                type="text"
                                                placeholder="Remarks for Modification"
                                                maxLength={256}
                                                value={bulkRemarks[inv.id] || ""}
                                                onChange={(e) =>
                                                    handleBulkRemarkChange(inv.id, e.target.value)
                                                }
                                                style={{ margin: "0px" }}
                                            />
                                            <span className="bulk-counter">
                                                {(bulkRemarks[inv.id] || "").length}/256
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>

                        <div className="popup-bulk-modification-footer">
                            <button onClick={() => setIsBulkModificationOpen(false)}>
                                Cancel
                            </button>
                            <button onClick={handleBulkModificationSubmit}>
                                Submit
                            </button>
                        </div>
                    </div>
                </div >
            )}
            {isBulkDeleteOpen && (
                <div className="modification-modal popup-bulk-modification" onClick={() => setIsBulkDeleteOpen(false)}>
                    <div className="popup-bulk-modification-container" onClick={(e) => e.stopPropagation()}>
                        <div className="popup-bulk-modification-header">
                            <h3>Bulk Delete</h3>
                        </div>

                        <div className="popup-bulk-modification-body">
                            {bulkDeleteInvoices.map(inv => (
                                <div className="bulk-modification-row" key={inv.id}>
                                    <div className="bulk-left">
                                        <p className="bulk-title">{inv.inv_number}</p>
                                        <p className="bulk-sub">
                                            Status : <span>{inv.approval_status}</span>
                                        </p>
                                    </div>

                                    <div className="bulk-divider"></div>

                                    <div className="bulk-right">
                                        <label className="bulk-label">Delete Remarks</label>

                                        <div className="bulk-input-wrapper">
                                            <input
                                                type="text"
                                                maxLength={256}
                                                style={{ margin: '0px' }}
                                                placeholder="Enter delete reason"
                                                value={bulkDeleteRemarks[inv.id] || ""}
                                                onChange={(e) =>
                                                    setBulkDeleteRemarks(prev => ({
                                                        ...prev,
                                                        [inv.id]: e.target.value
                                                    }))
                                                }
                                            />
                                            <span className="bulk-counter">
                                                {(bulkDeleteRemarks[inv.id] || "").length}/256
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>

                        <div className="popup-bulk-modification-footer">
                            <button onClick={() => setIsBulkDeleteOpen(false)}>Cancel</button>
                            <button onClick={handleBulkDeleteSubmit}>Delete</button>
                        </div>
                    </div>
                </div>
            )}
            <ToastContainer position="top-right" autoClose={2000} hideProgressBar={false} />
        </>
    )
}


export default SalesInvoice
